/**
 * Kanonische Projektrouten (Paket 14).
 *
 * Die URL ist die Wahrheit des Projektkontexts — kein globaler Filter.
 */

export type Arbeitsbereich =
  | { art: "dashboard" }
  | { art: "projekt"; projektId: string };

export function pfadSeitenGlobal(): string {
  return "/seiten";
}

export function pfadProjektSeiten(projektId: string): string {
  return `/projekte/${projektId}/seiten`;
}

export function pfadSeite(projektId: string, seiteId: string): string {
  return `/projekte/${projektId}/seiten/${seiteId}`;
}

export function pfadProjekt(projektId: string): string {
  return `/projekte/${projektId}`;
}

export function pfadProjektAufgaben(projektId: string): string {
  return `/projekte/${projektId}/aufgaben`;
}

/**
 * Zielroute beim Wechsel des Arbeitsbereichs.
 * Eine seiteId wird nie in ein anderes Projekt mitgenommen.
 */
export function zielBeiArbeitsbereichWechsel(
  von: { pathname: string },
  neu: Arbeitsbereich,
): string {
  const istSeiten = von.pathname.includes("/seiten");
  const istAufgaben = von.pathname.includes("/aufgaben");

  if (neu.art === "dashboard") {
    if (istSeiten) return pfadSeitenGlobal();
    if (istAufgaben) return "/aufgaben";
    return "/";
  }

  if (istSeiten) return pfadProjektSeiten(neu.projektId);
  if (istAufgaben) return pfadProjektAufgaben(neu.projektId);
  return pfadProjekt(neu.projektId);
}

/**
 * In welchem Projekt eine Anlegen-Aktion außerhalb einer Projektroute wirkt.
 *
 * Die globale Seitenliste kennt kein Projekt aus der URL, eine Seite braucht
 * aber eines — die Sichtbarkeitsgrenze ist das Projekt. Bei genau einem
 * sichtbaren Projekt ist die Frage schon beantwortet; sie zu stellen wäre eine
 * Auswahl ohne Wahl. Eine ausdrückliche Wahl gewinnt immer, auch wenn das
 * gewählte Projekt inzwischen verschwunden ist — dann ist der leere Rückgabe-
 * wert richtig, denn die Aktion darf nicht still im falschen Projekt landen.
 */
export function wirksamesProjekt(
  sichtbare: readonly { id: string }[],
  gewaehlt: string,
): string {
  if (gewaehlt) {
    return sichtbare.some((p) => p.id === gewaehlt) ? gewaehlt : "";
  }
  return sichtbare.length === 1 ? sichtbare[0]!.id : "";
}

/** Alte Reiter-URLs auf kanonische Pfade. */
export function kanonisiereProjektReiter(
  projektId: string,
  reiter: string | undefined,
): string | null {
  switch (reiter) {
    case "seiten":
      return pfadProjektSeiten(projektId);
    case "aufgaben":
      return pfadProjektAufgaben(projektId);
    case "meilensteine":
      return `/projekte/${projektId}/meilensteine`;
    case "personen":
      return `/projekte/${projektId}/personen`;
    default:
      return null;
  }
}
